import { formHelper } from '@/features/project-facade/helpers'

const { validationSchema: productValidationSchema } = formHelper.validation.validationHelper.product

export const validationSchema = productValidationSchema
